import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IClientProperty } from '@clients/models/firebase/client.model';
import { ClientsService } from '@clients/services/clients/clients.service';
import { PageSubtitleComponent } from '@shared/components/sections/page-subtitle/page-subtitle.component';
import { ToastTypes } from '@shared/models/toast';
import { ModalService } from '@shared/services/modal/modal.service';
import { ToastService } from '@shared/services/toast/toast.service';

import { AddPropertyModalComponent } from '../modals/add-property-modal/add-property-modal.component';
import { EditPropertyModalComponent } from '../modals/edit-property-modal/edit-property-modal.component';

@Component({
	selector: 'app-desktop-client-edit-property-table',
	imports: [CommonModule, PageSubtitleComponent],
	templateUrl: './desktop-client-edit-property-table.component.html',
	styleUrl: './desktop-client-edit-property-table.component.scss',
})
export class DesktopClientEditPropertyTableComponent {
	@Input() properties: Array<IClientProperty>;
	@Input() clientId: string;
	@Output() propertyChange: EventEmitter<void> = new EventEmitter<void>();
	private modalService = inject(ModalService);
	private toastService = inject(ToastService);
	private clientsService = inject(ClientsService);

	openAddProperty(): void {
		const modalRef = this.modalService.open(AddPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as AddPropertyModalComponent;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.clientsService.addClientProperty(this.clientId, property).then(() => {
				this.toastService.showToast({
					title: 'Client',
					message: 'Added client property',
					type: ToastTypes.SUCCESS,
				});
			});
			this.propertyChange.emit();
		});
	}

	openEditProperty(clientProperty: IClientProperty): void {
		const modalRef = this.modalService.open(EditPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as EditPropertyModalComponent;
		componentInstance.clientProperty = clientProperty;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.clientsService.editClientProperty(this.clientId, property).then(() => {
				this.toastService.showToast({
					title: 'Client',
					message: 'Updated client property',
					type: ToastTypes.SUCCESS,
				});
			});
			this.propertyChange.emit();
		});
		componentInstance.propertyRemoved.pipe(take(1)).subscribe((propertyId: string) => {
			this.clientsService.removeClientProperty(this.clientId, propertyId).then(() => {
				this.toastService.showToast({
					title: 'Client',
					message: 'Removed client property',
					type: ToastTypes.SUCCESS,
				});
			});
			this.propertyChange.emit();
		});
	}
}
